"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegaMenuState = void 0;
var MegaMenuArticle_init_1 = require("@/pages/common/states/MegaMenuArticle.init");
var MegaMenuLocation_init_1 = require("@/pages/common/states/MegaMenuLocation.init");
var MegaMenuLayout_init_1 = require("./MegaMenuLayout.init");
var getBuyPopularDistricts = function () {
    var newPopularDistricts = __spreadArrays(MegaMenuLocation_init_1.popularDistricts);
    newPopularDistricts.sort(function (it) { return it.id; });
    return newPopularDistricts;
};
exports.defaultMegaMenuState = {
    buyPopupActive: false,
    aboutUsPopupActive: false,
    agentPopupActive: false,
    rentPopupActive: false,
    resourcesPopupActive: false,
    languagesPopupActive: false,
    mobileMenuActive: false,
    accountActive: false,
    favoriteActive: false,
    mobileLangActive: false,
    popularBuildingBuyActive: false,
    popularBuildingRentActive: false,
    popularDistrictBuyActive: false,
    popularDistrictRentActive: false,
    newAndInsights: MegaMenuArticle_init_1.defaultMegaMenuArticles,
    inThePress: MegaMenuArticle_init_1.defaultMegaMenuArticles.slice(0, 2),
    rentPopularDistricts: MegaMenuLocation_init_1.popularDistricts,
    rentDistricts: MegaMenuLocation_init_1.districts,
    rentPopularBuildings: MegaMenuLocation_init_1.popularBuildings,
    rentBuildings: MegaMenuLocation_init_1.buildings,
    buyPopularDistricts: getBuyPopularDistricts(),
    buyDistricts: MegaMenuLocation_init_1.districts,
    buyPopularBuildings: MegaMenuLocation_init_1.popularBuildings,
    buyBuildings: MegaMenuLocation_init_1.buildings,
    buildingLayouts: MegaMenuLayout_init_1.buildingLayouts,
    isResourceSaleActive: true,
    isResourceRentActive: false,
    isMobileResourcePopularDistrictsActive: false,
    isMobileResourcePopularBuildingsActive: false,
    rentPopularDistrictsResources: MegaMenuLocation_init_1.popularDistricts,
    popularDistricts: MegaMenuLocation_init_1.districts,
    popularBuildings: MegaMenuLocation_init_1.buildings,
    rentDistrictsResources: MegaMenuLocation_init_1.districts,
    rentPopularBuildingsResources: MegaMenuLocation_init_1.popularBuildings,
    rentBuildingsResources: MegaMenuLocation_init_1.buildings,
    buyPopularDistrictsResources: getBuyPopularDistricts(),
    buyDistrictsResources: MegaMenuLocation_init_1.districts,
    buyPopularBuildingsResources: MegaMenuLocation_init_1.popularBuildings,
    buyBuildingsResources: MegaMenuLocation_init_1.buildings,
};
